import { apiRequest } from '../../shared/api/base'

// Re-export connection API from shared location
export type { CalendarInfo, ConnectionInfo } from '../../shared/api/connections'
export { getConnections, connectGoogleGmail, disconnectService } from '../../shared/api/connections'

/** @deprecated Use connectGoogle() instead */
export { connectGoogle as connectGoogleCalendar } from '../../shared/api/connections'

// ─── Profile types ──────────────────────────────────────────

export interface ProfileData {
  firstName: string | null
  lastName: string | null
  email: string
  location: string | null
}

// ─── API functions ──────────────────────────────────────────

export async function getProfile(): Promise<ProfileData> {
  return apiRequest<ProfileData>('/settings/profile')
}

export async function updateProfile(data: { firstName?: string; lastName?: string; location?: string }): Promise<ProfileData> {
  return apiRequest<ProfileData>('/settings/profile', {
    method: 'PATCH',
    body: JSON.stringify(data),
  })
}

export async function deleteAccount(): Promise<{ status: 'deleted' }> {
  return apiRequest<{ status: 'deleted' }>('/settings/profile', {
    method: 'DELETE',
  })
}
